const FEATUREBASE_SDK_ID = "featurebase-sdk";
const FEATUREBASE_SDK_URL = "https://do.featurebase.app/js/sdk.js";

let loadPromise = null;

function ensureFeaturebaseStub() {
  if (typeof window.Featurebase !== "function") {
    window.Featurebase = function FeaturebaseStub() {
      (window.Featurebase.q = window.Featurebase.q || []).push(arguments);
    };
  }
}

/** @internal test helper */
export function resetLoadFeaturebaseSdkForTests() {
  loadPromise = null;
  delete window.__featurebaseSdkLoaded;
  document.getElementById(FEATUREBASE_SDK_ID)?.remove();
}

/**
 * Lazily injects the Featurebase SDK once the authenticated app UI needs it.
 * Safe to call from multiple mounts; concurrent callers share one promise.
 */
export function loadFeaturebaseSdk() {
  ensureFeaturebaseStub();

  if (window.__featurebaseSdkLoaded) {
    return Promise.resolve();
  }

  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise((resolve, reject) => {
    const existing = document.getElementById(FEATUREBASE_SDK_ID);
    if (existing) {
      if (existing.dataset.loaded === "true") {
        window.__featurebaseSdkLoaded = true;
        resolve();
        return;
      }

      const onLoad = () => {
        existing.dataset.loaded = "true";
        window.__featurebaseSdkLoaded = true;
        resolve();
      };
      const onError = () => {
        loadPromise = null;
        reject(new Error("Failed to load Featurebase SDK"));
      };
      existing.addEventListener("load", onLoad, { once: true });
      existing.addEventListener("error", onError, { once: true });
      return;
    }

    const script = document.createElement("script");
    script.id = FEATUREBASE_SDK_ID;
    script.src = FEATUREBASE_SDK_URL;
    script.async = true;
    script.onload = () => {
      script.dataset.loaded = "true";
      window.__featurebaseSdkLoaded = true;
      resolve();
    };
    script.onerror = () => {
      loadPromise = null;
      reject(new Error("Failed to load Featurebase SDK"));
    };
    document.head.appendChild(script);
  });

  return loadPromise;
}
